import React from 'react';
import methodModel from '../../../methods/methods';
import ImageUpload from '../../../components/common/ImageUpload';
import Layout from '../../../components/global/layout';
import rolesModel from '../../../models/roles.model';
import SelectDropdown from '../../../components/common/SelectDropdown';
import PhoneInput from 'react-phone-input-2';
import { Tooltip } from 'antd';
import GooglePlaceAutoComplete from '../../../components/common/GooglePlaceAutoComplete';

const Html = ({
  role,
  form,
  handleSubmit,
  setform,
  roles,
  addressResult,
  submitted,
  images,
  imageResult,
  getError,
  setEyes,
  eyes,
  back,
  emailCheck,
  emailErr,
  emailLoader,
  detail,
}) => {
  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="false" name="addUser">
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all    mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {form && form.id ? 'Edit' : 'Add'}{' '}
                  {role ? rolesModel.name(role) : 'User'}
                </h3>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6">
                <label>
                  First Name<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form?.firstName}

                  // onChange={(e) =>

                  //   setform({ ...form,firstName: e.target.value })
                  // }
    
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const filteredValue = inputValue.replace(/[^A-Za-z]/ig, '')

                    setform({ ...form, firstName: filteredValue });
                  }}

                />
                {submitted && !form?.firstName ? (
                  <div className="invalid-feedback d-block">
                    First Name is Required
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>
                  Last Name
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form?.lastName}
                  // onChange={(e) =>
                  //   setform({ ...form, lastName: e.target.value })
                  // } 
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const lastfilteredValue = inputValue.replace(/[^A-Za-z']/ig, '')

                    setform({ ...form, lastName: lastfilteredValue });
                  }}
                />
                {/* {submitted && !form?.lastName ? (
                  <div className="invalid-feedback d-block">
                    Last Name is Required
                  </div>
                ) : (
                  <></>
                )} */}
              </div>
              <div className="col-span-12 md:col-span-6">
                <label>Bio</label>
                <textarea
                  cols="60"
                  rows="10"
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2  focus-visible:outline-0 px-2"
                  placeholder="Bio"
                  value={form.bio ? form.bio : ''}
                  onChange={e => setform({ ...form, bio: e.target.value })}
                />
              </div>
              {role ? (
                <></>
              ) : (
                <div className="col-span-12 md:col-span-6 ">
                  <label>
                    Role<span className="star">*</span>
                  </label>
                  <SelectDropdown
                    id="statusDropdown"
                    displayValue="name"
                    placeholder="Select Role"
                    intialValue={form?.role}
                    country="1"
                    disabled={form?.id ? true : false}
                    result={(e) => {
                      setform({ ...form, role: e.value });
                    }}
                    options={roles}
                  />
                  {submitted && !form.role ? (
                    <div className="invalid-feedback d-block">
                      Role is Required
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Gender
                </label>
                <SelectDropdown
                  id="statusDropdown"
                  displayValue="name"
                  placeholder="Select Gender"
                  intialValue={form?.gender}
                  country="1"
                  disabled={form?.id && form?.gender != ""}
                  result={(e) => {
                    setform({ ...form, gender: e.value });
                  }}
                  options={[
                    { id: 'male', name: 'Male' },
                    { id: 'female', name: 'Female' },
                    { id: 'others', name: 'Other' },
                  ]}
                />
                {/* {submitted && !form.gender ? (
                  <div className="invalid-feedback d-block">
                    Gender is Required
                  </div>
                ) : (
                  <></>
                )} */}
              </div>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Mobile No.
                </label>
                <div className="mobile_number">
                  <PhoneInput
                    value={form?.dialCode + '' + form?.mobileNo}
                    country={'us'}
                    // placeholder='Moblie No'
                    enableSearch={true}
                    limitMaxLength
                    required
                    onChange={(e, a) => {
                      let phonenumber = e.replace(a.dialCode, '');
                      setform({
                        ...form,
                        mobileNo: phonenumber,
                        dialCode: a?.dialCode,
                      });
                    }}
                    countryCodeEditable={true}
                  />
                </div>

                {/* {submitted && form?.mobileNo?.lenght < 10 ? (
                  <div className="invalid-feedback d-block">
                    Min Length is 10
                  </div>
                ) : (
                  <></>
                )} */}

              </div>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Email<span className="star">*</span>
                </label>
                <input
                  type="email"
                  // pattern="/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  autoComplete="false"
                  value={form.email}
                  onChange={(e) => {
                    setform({ ...form, email: e.target.value });
                  }}
                  //   required
                  disabled={form?.id ? true : false}
                />
                {submitted && getError('email').invalid ? (
                  <div className="invalid-feedback d-block">
                    Email is Invalid
                  </div>
                ) : (
                  <></>
                )}

                {submitted && !form.email ? (
                  <div className="invalid-feedback d-block">
                    Email is Required
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {/* <div className="col-span-12 md:col-span-6 ">
                <label>Address</label>

                <GooglePlaceAutoComplete
                  result={addressResult}
                  placeholder={'Address'}
                  key={'User_Address'}
                  value={form?.address}
                />
              </div> */}
              {/* <div className="col-span-12 md:col-span-6 ">
                <label>Password</label>
                <div className="inputWrapper">
                  <input
                    type={eyes.password ? 'text' : 'password'}
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form.password}
                    autoComplete="new-password"
                    onChange={(e) =>
                      setform({ ...form, password: e.target.value })
                    }
                  />
                  <i
                    className={
                      eyes.password
                        ? 'fa fa-eye text-gray-200 text-xs'
                        : 'fa fa-eye-slash text-gray-200 text-xs'
                    }
                    onClick={() =>
                      setEyes({ ...eyes, password: !eyes.password })
                    }
                  ></i>
                </div>
                {submitted && getError('password').invalid ? (
                  <div className="invalid-feedback d-block">
                    Password minimum length should be 8
                  </div>
                ) : (
                  <></>
                )}
              </div> */}
              {/* <div className="col-span-12 md:col-span-6 ">
                <label>
                  Confirm Password{' '}
                  {form.password ? <span className="star">*</span> : <></>}
                </label>
                <div className="inputWrapper">
                  <input
                    type={eyes.confirmPassword ? 'text' : 'password'}
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form.confirmPassword}
                    onChange={(e) =>
                      setform({ ...form, confirmPassword: e.target.value })
                    }
                    required={form.password ? true : false}
                  />
                  <i
                    className={
                      eyes.confirmPassword
                        ? 'fa fa-eye text-gray-200 text-xs'
                        : 'fa fa-eye-slash text-gray-200 text-xs'
                    }
                    onClick={() =>
                      setEyes({
                        ...eyes,
                        confirmPassword: !eyes.confirmPassword,
                      })
                    }
                  ></i>
                </div>
                {submitted && getError('confirmPassword').invalid ? (
                  <div className="invalid-feedback d-block">
                    Confirm Password is not matched with Password
                  </div>
                ) : (
                  <></>
                )}
              </div> */}
              <div className="col-span-12 md:col-span-12 ">
                <label className="lablefontcls">Image</label>
                <br></br>
                <ImageUpload
                  model="users"
                  result={(e) => imageResult(e, 'image')}
                  value={images.image || form.image}
                  multiple={false}
                />
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default Html;
